@if (messageSent()) {
<div>
	<lib-message [type]="'success'" [title]="'Success'"
		>Your message has been sent. We'll get back to you soon.</lib-message
	>
</div>
} @else {
<div>
	<lib-card [isForm]="true" [enableCard]="enableCard()">
		<ui-text-form-field
			[title]="'E-mail'"
			[isRequired]="true"
			[validation]="'email'"
			[valueAsSignal]="form.email"
			[maxLength]="emailMaxLength"
		></ui-text-form-field>

		<ui-text-area-form-field
			class="push-top-md"
			[isRequired]="true"
			[valueAsSignal]="form.message"
			[maxLength]="messagelMaxLength"
			[enableEmoji]="false"
			[enableGenAi]="false"
		></ui-text-area-form-field>

		<ui-form-save-button
			[title]="'Send'"
			[removeDivider]="true"
			[saveHandler]="saveHandler()"
			[logHandler]="formLogHandler()"
		></ui-form-save-button>
	</lib-card>
</div>
}
